import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPanelComponent } from './routes/map-panel/map-panel.component';
import {TranslateModule} from "@ngx-translate/core";
import {SharedModule} from "@shared/shared.module";

@NgModule({
    declarations: [
        MapPanelComponent
    ],
    exports: [
        MapPanelComponent
    ],
  imports: [
    CommonModule,
    TranslateModule,
    SharedModule
  ]
})
export class MapPanelModule { }
